// Core imports
import * as React from 'react';
import i18n from 'src/translation/i18n';
import { commentsRegEx } from 'src/utils/RegexUtils';
import './WrongPartShippedMoreInfo.scss';

// utils regex
import { emailcapsRegEx } from 'src/utils/RegexUtils';

class WrongPartShippedMoreInfo extends React.Component<IWrongPartShippedMoreInfoProps, any> {
  constructor(props: IWrongPartShippedMoreInfoProps) {
    super(props);
  }
 
  public render() {
    return (
      <div style={{ marginBottom: '10px'}}>
        <h4>{i18n.t('warrantyView.moreInfo')}</h4>
        <div className="form-row row  ">
          <div className={`form-group col-sm-12 col-md-6 col-lg-12 mb ${this.props.DamageErrormsgshow && this.props.DamageisPartMatchOnInvoceAndBox==='' ? 'error-border' : ''}`}>
              <label>
                {i18n.t('partClaim.wrongPartInvoiceMatch')}*
                </label>
                    <div className='claim-radio-contaner'>
                    <div>
                    <input
                    id="radio1"
                    name="isPartMatchOnInvoceAndBox"
                    type="radio"
                    value={"Yes"}
                    checked={this.props.DamageisPartMatchOnInvoceAndBox === "Yes"}
                    onChange={e => this.props.handleRadioChange(e)}
                  />
                  <label>Yes</label>
                  </div>
                  <div>
                  <input
                    id="radio1"
                    name="isPartMatchOnInvoceAndBox"
                    type="radio"
                    value={"No"}
                    checked={this.props.DamageisPartMatchOnInvoceAndBox === "No"}
                    onChange={e => this.props.handleRadioChange(e)}
                  />
                  <label>No</label>
                  </div>
              </div>
          </div>


          <div className={`form-group col-sm-12 col-md-6 col-lg-12 mb ${this.props.DamageErrormsgshow && this.props.DamageisPartMatchOnBoxAndPhysical==='' ? 'error-border' : ''}`}>
              <label>
                {i18n.t('partClaim.wrongPartPhysicalParteMatch')}*
                </label>
                    <div className='claim-radio-contaner'>
                    <div>
                    <input
                    id="radio1"
                    name="isPartMatchOnBoxAndPhysical"
                    type="radio"
                    value={"Yes"}
                    checked={this.props.DamageisPartMatchOnBoxAndPhysical === "Yes"}
                    onChange={e => this.props.handleRadioChangePhysical(e)}
                  />
                  <label>Yes</label>
                  </div>
                  <div>
                  <input
                    id="radio1"
                    name="isPartMatchOnBoxAndPhysical"
                    type="radio"
                    value={"No"}
                    checked={this.props.DamageisPartMatchOnBoxAndPhysical === "No"}
                    onChange={e => this.props.handleRadioChangePhysical(e)}
                  />
                  <label>No</label>
                  </div>
                  <div>
                  <input
                    id="radio1"
                    name="isPartMatchOnBoxAndPhysical"
                    type="radio"
                    value={"Not Sure"}
                    checked={this.props.DamageisPartMatchOnBoxAndPhysical === "Not Sure"}
                    onChange={e => this.props.handleRadioChangePhysical(e)}
                  />
                  <label>Not Sure</label>
                </div>
              </div>
          </div> 

          <div className="form-group col-sm-12 col-md-6 col-lg-12 mb">
              <div>
                  <label>{i18n.t('partClaim.wrongPartAdditionalComment')}:</label>
              </div>
              <div className='description-box'>
                <input
                className='form-control-claims'
                name="addtionalComment"
                type="text"
                value={this.props.DamageAdditionalComment}
                onChange={e => this.props.handleAdditionalComment(e)}
              />
             
                    <div>
                    {this.props.DamageErrorlistservice
                      ?.DamageAdditionalCommentError ? (
                        this.props.DamageErrorlistservice === '' ? (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.reqfield')}
                        </span>
                      ) : !/\S/.test(this.props.DamageErrorlistservice) ? (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.atleastchar')}
                        </span>
                      ) : this.props.DamageErrorlistservice.length > 250 ? (
                        !commentsRegEx.test(this.props.DamageErrorlistservice) ? (
                          <>
                            <span className="rp-warranty-input-error-internal">
                              {i18n.t('damageClaim.maxeigchar')}
                            </span>
                            <p className="rp-warranty-input-error-internal">
                              {i18n.t('partClaim.tracknumerror')}(
                              {i18n.t('partClaim.noSymbols')})
                            </p>
                          </>
                        ) : (
                          <span className="rp-warranty-input-error-internal">
                            ({i18n.t('damageClaim.maxeigchar')})
                          </span>
                        )
                      ) : (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.tracknumerror')}(
                          {i18n.t('partClaim.noSymbols')})
                        </span>
                      )
                    ) : (
                      <span className="input-info">
                        <i>
                          {' '}
                          ({i18n.t('damageClaim.maxeigchar')}){''}
                          {i18n.t('partClaim.tracknumerror')}(
                          {i18n.t('partClaim.noSymbols')})
                        </i>{' '}
                      </span>
                    )}
                  </div>
              </div>
          </div>
          
        </div>
      </div>
    );
  }
}

export default WrongPartShippedMoreInfo;

interface IWrongPartShippedMoreInfoProps {
  DamageisPartMatchOnInvoceAndBox: string;
  DamageisPartMatchOnBoxAndPhysical: string;
  DamageAdditionalComment: string;
  DamageErrorlistservice: any;
  DamageErrormsgshow: boolean;
  handleAdditionalComment: (event: any) => void;
  handleRadioChange: (event: any) => void;
  handleRadioChangePhysical: (event: any) => void;
}
